<!-- custom-date-picker.component.html -->
<div class="date-picker">
  <div class="date-input-container input" [ngClass]="{'disabled': isDisabled}">
    <div class="d-flex justify-content-start align-items-center dates-input-container">
      <input type="text" class="days-input date" placeholder="dd" [appMaxLength]="2" [(ngModel)]="day" [disabled]="isDisabled" 
        (blur)="onInputChange('day', $event)" />
      <p class="slash">/</p>
      <input type="text" class="months-input date" placeholder="mm" [appMaxLength]="2" [(ngModel)]="month" [disabled]="isDisabled" 
        (blur)="onInputChange('month', $event)" />
      <p class="slash">/</p>
      <input type="text" class="years-input date" placeholder="yyyy" [appMaxLength]="4" [(ngModel)]="year" [disabled]="isDisabled" 
        (blur)="onInputChange('year', $event)" />
    </div>

    <button class="calendar-btn" [disabled]="isDisabled" (click)="openCalendar($event)" type="button">
      <ion-icon name="calendar-outline"></ion-icon>
    </button>
  </div>
</div>